import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import Advertisement from './Advertisement';
import HomeSavedSearch from './SavedSearch';
import RecentSearch from './RecentSearch';
import FeatureStone from './FeatureStone';
import Slider from './Slider';
import KAMDetail from './KAMDetail';
import MyPurchase from './MyPurchase';
import DashboardRight from './DashboardRight';
import UpdateProfile from './UpdateProfile';
import UtilService from '../../services/util';
import CommonModal from '../common/CommonModal';
import {
  GET_DASHBOARD_DATA,
  ACCOUNT_UPDATE_KYC,
  GET_MYPURCHASE_DATA,
  GET_BANNERS,
  UPLOAD_FILE,
} from '../../constants/apiConstant';
import { LOCAL_STORAGE_VAR, KYC_STATUS, BANNER_TYPE, USERS_TYPE } from '../../constants/Common';
import OpenNotification from '../common/CommonButton/OpenNotification';
import { switchStoneType } from 'appRedux/actions/Common';
import { store } from 'appRedux/store/index';

let gridHeight = 0;
export function setGridHeightFn() {
  const allContainers = {};
  let totalHeight = window.innerHeight - 18;
  allContainers.HeaderStripBlock = document.getElementsByClassName('HeaderStripBlock ')[0];
  allContainers.smallHeaderWrapper = document.getElementsByClassName('smallHeaderWrapper ')[0];

  Object.keys(allContainers).map((key) => {
    if (allContainers[key] && allContainers[key].offsetHeight) {
      totalHeight = totalHeight - allContainers[key].offsetHeight;
    }
    // {console.log(offsetHeight,"height")};
    return true;
  });
  return totalHeight;
}
class Home extends Component {
  state = {
    visible: false,
    dashData: undefined,
    purchaseData: undefined,
    gridHeight: 0,
    page: 1,
    limit: 100,
    bannerDataSlider: [],
    bannerDataTop: {},
    bestBuyBanner: false,
    stoneTypeBanner: false,
    Kyc: {
      imageOne: '',
      imageTwo: '',
    },
  };

  loginUser = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);

  setModel = () => {
    this.loginUser = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);

    const visible =
      this.loginUser?.type === USERS_TYPE.PRIMARY &&
      this.loginUser?.kycRequired &&
      !this.loginUser?.account?.isKycUploaded;
    this.setState({
      visible,
      bestBuyBanner: !visible && !UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-best-buy-visit-done`),
      stoneTypeBanner: (this.loginUser?.account?.showNatural && this.loginUser?.account?.showLabGrown) && !localStorage.getItem(`${LOCAL_STORAGE_VAR}-labGrown`),
    });
  };

  componentDidMount() {
    this.setModel();
    this.getDashBoardData();
    this.getMyPurchaseData();
    this.getBanners();
  }

  componentDidUpdate(prevProps) {
    if (this.props.commonData.strip !== prevProps.commonData.strip) this.forceUpdate();
  }

  getMyPurchaseData = () => {
    const obj = {
      ...GET_MYPURCHASE_DATA,
      request: {
        sort: [{ memoNo: 'DESC' }],
        page: this.state.page,
        limit: this.state.limit,
        filter: {
          status: 2,
        },
        analytics: {
          page: 'MyOrder',
          section: 'Diamonds',
          action: 'list',
        },
        labGrown: store.getState().commonData.labGrown,
      },
    };
    UtilService.callApi(obj, (err, res) => {
      if (res?.code === 'OK' && res.data.list?.length !== 0) {
        return this.setState({ purchaseData: res.data.list });
      }

      this.setState({ purchaseData: undefined });
    });
  };

  // GET_DASHBOARD_DATA
  getDashBoardData = () => {
    const obj = {
      ...GET_DASHBOARD_DATA,
      request: {
        savedSearch: true,
        recentSearch: true,
        track: true,
        account: true,
        seller: true,
        orderData: true,
        featuredStone: true,
        labGrown: store.getState().commonData.labGrown,
      },
    };
    UtilService.callApi(obj, (err, res) => {
      if (res?.code === 'OK' && res?.data) {
        this.setState({
          dashData: res.data,
          visible:
            this.loginUser?.type === USERS_TYPE.PRIMARY &&
            this.loginUser?.kycRequired &&
            !res?.data?.account?.isKycUploaded,
        });

        if (res.data.account) {
          const user = this.loginUser;
          user.account = res.data.account;
          UtilService.setLocalStorageItem(user, `${LOCAL_STORAGE_VAR}-user`);
        }
        return;
      }
      this.setState({ dashData: undefined, visible: false });
    });
  };

  getBanners = () => {
    const obj = {
      ...GET_BANNERS,
      request: {
        isActive: true,
        bannerType: ['1', '2'],
      },
    };
    // Status code is coming OK and message too wait
    UtilService.callApi(obj, (err, res) => {
      if (res?.code === 'OK') {
        this.setState({ bannerData: res.data.list }, () => {
          const bannerTop = find(this.state.bannerData, {
            type: BANNER_TYPE.HOMEPAGE_TOP,
          });
          const bannerBottom = find(this.state.bannerData, {
            type: BANNER_TYPE.HOMEPAGE_BOTTOM,
          });

          return this.setState({
            bannerDataSlider: bannerBottom,
            bannerDataTop: bannerTop,
          });
        });
      }
      this.setState({ bannerData: [] });
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
      bestBuyBanner: true,
    });
  };

  uploadKyc = (file, name, img) => {
    const objData = {
      ...UPLOAD_FILE,
      request: file,
    };
    UtilService.callApi(objData, (err, data) => {
      if (err) throw err;
      if (data && data.code === 'OK') {
        if (data.data && data.data.files && data.data.files.length !== 0) {
          if (img === 1) {
            this.setState({
              Kyc: {
                imageTwo: this.state.Kyc.imageTwo,
                imageOne: data.data.files[0].absolutePath,
              },
            });
          } else {
            this.setState({
              Kyc: {
                imageOne: this.state.Kyc.imageOne,
                imageTwo: data.data.files[0].absolutePath,
              },
            });
          }
          OpenNotification({
            type: 'success',
            title: 'Document uploaded successfully.',
          });
        }
      }
    });
  };
  createKyc = () => {
    if (this.state.Kyc && this.state.Kyc.imageOne !== '' && this.state.Kyc.imageTwo !== '') {
      const user = this.loginUser;
      const objReq = {
        url: ACCOUNT_UPDATE_KYC.url + user.account.id,
        method: ACCOUNT_UPDATE_KYC.method,
        showLoader: ACCOUNT_UPDATE_KYC.showLoader,
        request: {
          kyc: [{ path: this.state.Kyc.imageOne }, { path: this.state.Kyc.imageTwo }],
          isKycUploaded: true,
          isApproved: KYC_STATUS.PENDING,
        },
      };
      UtilService.callApi(objReq, (err, data) => {
        if (err) throw err;
        if (data && data.code === 'OK') {
          user.account.isKycUploaded = true;
          user.account.kyc = objReq.request.kyc;
          user.account.isApproved = KYC_STATUS.PENDING;

          UtilService.setLocalStorageItem(user, `${LOCAL_STORAGE_VAR}-user`);
          OpenNotification({
            type: 'success',
            title: 'Your KYC documents are successfully submitted.',
          });
          this.onClose();
        }
      });
    } else {
      OpenNotification({
        type: 'error',
        title: 'Please upload both the images',
      });
    }
  };

  handleBestBuyRedirect = () => {
    UtilService.setLocalStorageItem(true, `${LOCAL_STORAGE_VAR}-best-buy-visit-done`);
    this.props.history.push('/best-buy');
  };

  handleBestBuyClose = () => {
    this.setState({ bestBuyBanner: false });
    UtilService.setLocalStorageItem(true, `${LOCAL_STORAGE_VAR}-best-buy-visit-done`);
  };
  render() {
    gridHeight = setGridHeightFn();
    const { dashData, purchaseData, bannerDataTop, bannerDataSlider } = this.state;

    return (
      <>
        <div className="homePageMainWrapper">
          <div className="homePageLeft" style={{ height: gridHeight, overflow: 'auto' }}>
            <div className="homepageLeftScroll">
              <Advertisement image={bannerDataTop} />
              <div className="dashboardTwoBlock d-flex flex-wrap">
                <div className="homeRightInner">
                  <HomeSavedSearch save={dashData && dashData.savedSearch} />
                </div>
                <div className="homeRightInner">
                  <RecentSearch recent={dashData && dashData.recentSearch} />
                </div>
              </div>
              {/* {dashData &&
                !isEmpty(dashData.featuredStone) &&
                console.log(
                  "find => ",
                  dashData.featuredStone.map((x) => x.featuredPair).flat()
                    .length
                )} */}
              {dashData &&
                !isEmpty(dashData.featuredStone) &&
                dashData.featuredStone.map((x) => x.featuredPair).flat().length > 0 && (
                  <div className="homeRightInner width-100 mt-20">
                    <FeatureStone stones={dashData.featuredStone.map((x) => x.featuredPair).flat()} />
                  </div>
                )}
              <div className="dashboardTwoBlock d-flex flex-wrap">
                <div className=" dashboardLargeRight homeRightInner">
                  <MyPurchase purchase={purchaseData} />
                </div>
                <div className="dashboardSamllLeft homeRightInner">
                  <KAMDetail seller={dashData && dashData.seller} />
                </div>
              </div>
              <div>
                <Slider images={bannerDataSlider} />
              </div>
            </div>
          </div>
          <DashboardRight
            tracks={dashData && dashData.tracks}
            orderData={dashData && dashData.orderData}
            style={{ height: gridHeight, overflow: 'auto' }}
          />
        </div>
        <CommonModal
          title="Upload KYC"
          handleOk={this.createKyc}
          handleCancel={() => {
            this.onClose();
          }}
          visible={this.state.visible}
          wrapClassName="diamondListinSidebar"
          footerShow
          kyc
          submitTitle={`${!this.loginUser?.account?.isKycUploaded ? 'Submit' : ''}`}
          cancelTitle={`${this.loginUser?.account?.isKycUploaded ? 'Ok' : 'Skip'}`}
          closable={false}
        >
          {this.loginUser?.account?.isKycUploaded ? (
            <span>
              <strong>Your documents for KYC is under review.</strong>
            </span>
          ) : (
            <UpdateProfile
              kyc
              imageOne={this.state.Kyc.imageOne}
              imageTwo={this.state.Kyc.imageTwo}
              getKycImage={this.uploadKyc}
              onClick={this.onClose}
            />
          )}
        </CommonModal>
        <CommonModal
          title="Best Buy"
          handleCancel={this.handleBestBuyClose}
          visible={this.state.bestBuyBanner}
          wrapClassName="diamondListinSidebar"
        >
          <span style={{ textAlign: 'center' }}>
            <p style={{ color: 'black' }}>
              Hi{' '}
              <strong>
                {this.loginUser.firstName} {this.loginUser.lastName},
              </strong>
            </p>
            <p style={{ color: 'black', fontSize: '20px' }}>Check out Our latest Best Buy stones.</p>
            <p>
              <a
                onClick={this.handleBestBuyRedirect}
                style={{ color: '#3f96c4', fontWeight: '600', textDecoration: 'underline' }}
              >
                {' '}
                Click here for List
              </a>
            </p>
          </span>
        </CommonModal>
        <CommonModal
          title="What inventory would you like to see?"
          visible={this.state.stoneTypeBanner}
          wrapClassName="diamondListinSidebar"
        >
          <span style={{ textAlign: 'center' }}>
            <p style={{ color: 'black' }}>
              You can always change between the two from the dropdown on the top-right corner.
            </p>
            <p style={{ display: "flex", gap: "10px" }}>
              <a className='tappableSelect'
                onClick={() => this.props.switchStoneType('N')}
              >
                Natural
              </a>

              <a className='tappableSelect'
                onClick={() => this.props.switchStoneType('Y')}
              >
                Lab-Grown
              </a>
            </p>
          </span>
        </CommonModal>
      </>
    );
  }
}
export default connect((props) => {
  return { commonData: props.commonData };
}, { switchStoneType })(withRouter(Home));
